import { render, staticRenderFns } from "./VvSpeechBubble.vue?vue&type=template&id=9c5dd2d6&scoped=true&"
import script from "./VvSpeechBubble.vue?vue&type=script&lang=js&"
export * from "./VvSpeechBubble.vue?vue&type=script&lang=js&"
import style0 from "./VvSpeechBubble.vue?vue&type=style&index=0&id=9c5dd2d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c5dd2d6",
  null
  
)

export default component.exports